// All outbound link data for the site, shared by the React app and the
// agent markdown generator. Keep URLs stable and free of dates so this
// file never needs seasonal edits.

export const eventCalendars = [
  {
    name: 'Telluride Official Events Calendar',
    description: 'Complete listing of events in Telluride',
    url: 'https://www.telluride.com/festivals-events/events/',
  },
  {
    name: 'Mountain Village Events',
    description: 'Events in the Mountain Village area',
    url: 'https://townofmountainvillage.com/explore/events/all-events/',
  },
];

export const festivals = [
  {
    name: 'Telluride Bluegrass Festival',
    description: 'Four days of music in Town Park each June',
    url: 'https://bluegrass.com/telluride/',
  },
  {
    name: 'Telluride Film Festival',
    description: 'World premieres over Labor Day weekend',
    url: 'https://www.telluridefilmfestival.org/',
  },
  {
    name: 'Telluride Jazz Festival',
    description: 'Jazz, funk, and soul in August',
    url: 'https://www.telluridejazz.org/',
  },
  {
    name: 'Telluride Blues & Brews',
    description: 'Blues acts and craft beer in September',
    url: 'https://www.tellurideblues.com/',
  },
  {
    name: 'All Telluride Festivals',
    description: 'The full festival lineup on telluride.com',
    url: 'https://www.telluride.com/festivals-events/festivals/',
  },
];

export const visitorsGuide = {
  name: 'Summer/Fall 2026 Visitors Guide',
  title: 'Official Guide to Telluride & Mountain Village — Summer/Fall 2026',
  description:
    "Your comprehensive guide to Telluride's summer and fall seasons. Discover lodging, dining, activities, and everything you need to plan your perfect mountain getaway.",
  shortDescription: 'Official Guide to Telluride & Mountain Village for summer/fall 2026.',
  url: 'https://issuu.com/visit_telluride/docs/official_guide_to_telluride_mountai_295df0f50310a5',
  image: '/images/visitorguide-summerfall2026-400.webp', // 400px wide; the card shows it at 160-192px
};

export const skiingLinks = [
  {
    name: 'Snow Report',
    description: 'Current conditions and snow totals',
    url: 'https://tellurideskiresort.com/snow-report-scrape/',
  },
  {
    name: 'Ski Passes',
    description: 'Lift tickets and season passes',
    url: 'https://tellurideskiresort.com/ski/',
  },
  {
    name: 'Epic Pass',
    description: 'Access Telluride and other world-class resorts',
    url: 'https://www.epicpass.com/',
  },
  {
    name: 'Telluride Nordic Association',
    description: 'Cross-country skiing and Nordic trail conditions',
    url: 'https://www.telluridenordic.com/nordic-trails',
  },
  {
    name: 'Winter Activities',
    description: 'Snowshoeing, ice climbing, sleigh rides, and more',
    url: 'https://www.telluride.com/things-to-do/winter-activities/',
  },
];

export const bikingLinks = [
  {
    name: 'Telluride Bike Park',
    description: 'Lift-served downhill trails off the gondola',
    url: 'https://tellurideskiresort.com/bike-park/',
  },
  {
    name: 'Biking in Telluride',
    description: 'Cross-country, road, and town trails',
    url: 'https://www.telluride.com/things-to-do/summer-fall-activities/biking/',
  },
  {
    name: 'Hiking Trails',
    description: 'Day hikes from town, the gondola, and the passes',
    url: 'https://www.telluride.com/things-to-do/summer-fall-activities/hiking/',
  },
  {
    name: 'Fishing',
    description: 'San Miguel River and high alpine lakes',
    url: 'https://www.telluride.com/things-to-do/summer-fall-activities/fishing/',
  },
  {
    name: 'All Summer & Fall Activities',
    description: 'Everything to do when the snow is gone',
    url: 'https://www.telluride.com/things-to-do/summer-fall-activities/',
  },
];

export const offroadingLinks = [
  {
    name: 'San Miguel County Pass Conditions',
    description: 'Current road conditions and closures',
    url: 'https://www.sanmiguelcountyco.gov/406/Pass-Conditions',
  },
  {
    name: 'Alpine Loop Status',
    description: 'Trail conditions and access information',
    url: 'https://www.alpineloop.info/',
  },
  {
    name: 'Ouray County Alert Center',
    description: 'Road alerts and emergency information',
    url: 'https://ouraycountyco.gov/AlertCenter.aspx',
  },
  {
    name: 'onX Offroad',
    description: 'Trail maps and navigation app',
    url: 'https://www.onxmaps.com/offroad/app',
  },
];

export const trails = [
  { name: 'Bridal Veil Falls', url: 'https://www.telluride.com/activity/bridal-veil-falls/' },
  { name: 'Black Bear Pass', url: 'https://www.telluride.com/activity/black-bear-pass/' },
  { name: 'Ophir Pass', url: 'https://www.telluride.com/activity/ophir-pass/' },
  { name: 'Imogene Pass', url: 'https://www.telluride.com/activity/imogene-pass/' },
  { name: 'Alta Lakes', url: 'https://www.telluride.com/activity/alta-lakes/' },
  { name: 'Tomboy Road & Ghost Town', url: 'https://www.telluride.com/activity/tomboy-ghost-town/' },
  { name: 'Last Dollar Road', url: 'https://www.telluride.com/activity/last-dollar-road/' },
  {
    name: 'Off-Roading Adventures in Telluride',
    url: 'https://www.telluride.com/things-to-do/summer-fall-activities/4x4-off-roading/',
  },
];

// Year-round, indoors, shown in both seasons.
export const cultureLinks = [
  {
    name: 'Telluride Historical Museum',
    description: 'Mining-era history in the old miners hospital',
    url: 'https://www.telluridemuseum.org/',
  },
  {
    name: 'Sheridan Opera House',
    description: 'Concerts, film, and theater in a 1913 landmark',
    url: 'https://sheridanoperahouse.com/',
  },
  {
    name: 'Ah Haa School for the Arts',
    description: 'Classes, workshops, and exhibitions',
    url: 'https://ahhaa.org/',
  },
  {
    name: 'Telluride Arts',
    description: 'Galleries, the monthly Art Walk, and the arts district',
    url: 'https://www.telluridearts.org/',
  },
  {
    name: 'Telluride Gallery of Fine Art',
    description: 'Contemporary art and jewelry on Main Street',
    url: 'https://www.telluridegallery.com/',
  },
  {
    name: 'Wilkinson Public Library',
    description: 'Talks, films, and a great place to wait out a storm',
    url: 'https://telluridelibrary.org/',
  },
];

export const diningLinks = [
  {
    name: "Allred's Restaurant",
    description: 'Fine dining at the top of the gondola with panoramic views',
    url: 'https://www.allredsrestaurant.com/',
  },
  {
    name: 'Brown Dog Pizza',
    description: 'Local favorite for pizza, subs, and salads',
    url: 'https://browndogpizza.com/',
  },
  {
    name: 'La Marmotte',
    description: 'French-inspired cuisine in a cozy downtown setting',
    url: 'https://www.lamarmotte.com/',
  },
  {
    name: 'Telluride Dining Guide',
    description: 'Browse all restaurants in Telluride and Mountain Village',
    url: 'https://www.telluride.com/food-drink/dining/',
  },
];

export const lodgingLinks = [
  {
    name: 'The Hotel Telluride',
    description: 'Boutique hotel steps from the gondola and downtown',
    url: 'https://www.thehoteltelluride.com/',
  },
  {
    name: 'Madeline Hotel & Residences',
    description: 'Luxury hotel in the heart of Mountain Village',
    url: 'https://www.madelinehotel.com/',
  },
  {
    name: 'New Sheridan Hotel',
    description: 'Historic 1891 hotel on Main Street, next to the Sheridan Opera House',
    url: 'https://newsheridan.com/',
  },
  {
    name: 'Telluride Lodging Guide',
    description: 'Find cabins, condos, hotels, and vacation rentals',
    url: 'https://www.telluride.com/lodging/',
  },
];

export const weatherLinks = [
  {
    name: 'Weather.gov — Telluride',
    description: 'Full NWS forecast and hourly detail',
    url: 'https://forecast.weather.gov/MapClick.php?lat=37.9375&lon=-107.8123',
  },
  {
    name: 'OpenSnow — Telluride',
    description: 'Detailed snow forecast and powder alerts',
    url: 'https://opensnow.com/location/telluride/snow-summary',
  },
  {
    name: 'Telluride Snow Report',
    description: 'Current base depth, new snow, and trail conditions',
    url: 'https://tellurideskiresort.com/snow-report-scrape/',
  },
];

export const gettingAroundLinks = [
  {
    name: 'Getting Here',
    description: 'Directions and travel options to reach Telluride',
    url: 'https://www.telluride.com/discover/getting-here/',
  },
  {
    name: 'The Gondola',
    description: 'Free gondola connecting Telluride and Mountain Village',
    url: 'https://www.telluride.com/discover/the-gondola/',
  },
  {
    name: 'Parking & Transportation',
    description: 'Parking locations, shuttles, and transit info',
    url: 'https://www.telluride.com/plan-your-visit/parking-transportation/',
  },
  {
    name: 'Public Transportation',
    description: 'Town of Telluride bus routes and schedules',
    url: 'https://www.telluride.gov/255/Public-Transit',
  },
];

export const visitorResources = [
  { name: 'Telluride.com — Official Visitors Site', url: 'https://www.telluride.com/' },
  {
    name: 'Visit Telluride — Visitor Center',
    url: 'https://www.telluride.com/plan-your-visit/visitors-center/',
  },
  { name: 'Town of Telluride', url: 'https://www.telluride.gov/' },
  { name: 'Wilkinson Public Library', url: 'https://telluridelibrary.org/' },
];

export const phoneNumbers = [
  { label: 'Emergency', value: '911', tel: '911', urgent: true },
  { label: 'Town Marshal', value: '(970) 728-3818', tel: '+19707283818' },
  { label: 'Medical Center', value: '(970) 728-3848', tel: '+19707283848' },
  { label: 'Ski Resort', value: '(970) 728-6900', tel: '+19707286900' },
];

// Resort webcams. `alias` is the ipcamlive player id embedded on each
// tellurideskiresort.com cam page; `url` is that page for attribution.
export const webcams = [
  {
    name: 'Mountain Village',
    alias: 'plazacam',
    description: 'Mountain Village Core looking toward Lift 4 and Misty Maiden',
    url: 'https://tellurideskiresort.com/webcams/village-cam/',
  },
  {
    name: 'See Forever',
    alias: 'jointpoint',
    description: 'Top of the mountain along the See Forever ridge',
    url: 'https://tellurideskiresort.com/webcams/see-forever-webcam/',
  },
  {
    name: 'Bon Vivant',
    alias: 'bonvivant',
    description: 'Bon Vivant restaurant deck and the Polar Queen Express',
    url: 'https://tellurideskiresort.com/webcams/bon-vivant-cam/',
  },
  {
    name: 'Hoot Brown',
    alias: 'hootbrown',
    description: 'Hoot Brown Terrain Park',
    url: 'https://tellurideskiresort.com/webcams/hoot-brown-terrain-park-webcam/',
  },
];

export const map = {
  name: 'Telluride, CO on Google Maps',
  url: 'https://www.google.com/maps?q=telluride,co',
  embed:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24955.81116221!2d-107.8820455!3d37.9374939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x873ed8469b8d60b7%3A0x88df5e7c8c577c82!2sTelluride%2C%20CO!5e0!3m2!1sen!2sus!4v1',
};

export const apps = [
  {
    name: 'Download on App Store',
    url: 'https://apps.apple.com/us/app/telluride-ski-resort/id1436432214',
  },
  {
    name: 'Get it on Google Play',
    url: 'https://play.google.com/store/apps/details?id=com.resortstapped.TELLURIDE&hl=en_US',
  },
];

export const contactEmail = 'info@tellurideevents.com';
